





























import { Component, Vue, Watch } from "vue-property-decorator";
import { getDefineImage, getUserInfo } from "@/req/user";
import recommend from "./avatorModel/recommend.vue";
import custom from "./avatorModel/custom.vue";
@Component({
  components: {
    recommend,
    custom,
  },
})
export default class Logout extends Vue {
  public showModel = false;
  public recommendList = []; // 推荐头像
  public active = 0; // 初始默认
  public recommendActive = null;
  public tabArr = ["recommend", "custom"];
  public tabCom = "recommend";
  public tabs = [
    {
      name: "推荐头像",
    },
    {
      name: "自定义头像",
    },
  ];
  @Watch("showModel")
  public isChange(val) {
    if (val) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }
  public activeIdx(val) {
    return this.recommendActive = val;
  }
  public show() {
    this.tabCom = "recommend";
    this.active = 0;
    this.getDefineImage();
    this.showModel = true;
  }
  public tabsSkip(index) {
    this.active = index;
    this.tabCom = this.tabArr[this.active];
  }
  // 获取推荐头像
  public async getDefineImage() {
    const res = await getDefineImage({
      token: this.$fn.cookies.getToken("token"),
    });
    this.recommendList = res.data.headImgList;
    const imgList = res.data.headImgList.filter((item) => {
      return item.img == this.$store.state.user.info.head_img;
    });
    if (JSON.stringify(imgList) != "[]") {
      this.recommendActive = imgList[0].id;
    }
  }
  /* // 更换头像
  public async getUserInfo() {
    const res = await getUserInfo({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code === 200) {
      this.$store.dispatch("user/authInfo", res.data.userinfo);
      this.$emit("avatorAmend");
      this.showModel = false;
    }
  } */
  public submitAvator(e) {
    this.$emit("submitAvator", e);
    this.showModel = false;
  }
}
